import React, { useState } from 'react';
import { getApiBase } from '../services/api';

export default function QuindicizzaPage() {
  return (
    <div className="page-content">
      <div style={{ marginBottom:16 }}>
        <h2 style={{ margin:'0 0 4px', fontSize:18 }}>📄 Quindicizza verbali</h2>
        <p style={{ margin:0, fontSize:13, color:'#6b7280' }}>
          Ribranding automatico dei verbali ricevuti dal fornitore
        </p>
      </div>
      <Quindicizza />
    </div>
  );
}

// ── QUINDICIZZA (ribranding verbali PDF) ──────────────────────
function Quindicizza() {
  const [file, setFile]       = useState(null);
  const [loading, setLoading] = useState(false);
  const [msg, setMsg]         = useState('');
  const [dragOver, setDragOver] = useState(false);

  const onFile = (f) => {
    if (!f) return;
    if (!f.name.toLowerCase().endsWith('.pdf')) {
      setMsg('⚠️ Seleziona un file PDF.');
      return;
    }
    setFile(f);
    setMsg('');
  };

  const elabora = async () => {
    if (!file) return;
    setLoading(true); setMsg('');
    try {
      const fd = new FormData();
      fd.append('file', file);

      const token = localStorage.getItem('quindi_token');
      const res = await fetch(`${getApiBase()}/api/quindicizza`, {
        method: 'POST',
        headers: { 'Authorization': 'Bearer ' + token },
        body: fd,
      });

      if (!res.ok) {
        let err = 'Errore durante l\'elaborazione.';
        try { const j = await res.json(); err = j.error || err; } catch {}
        throw new Error(err);
      }

      // Scarica il PDF risultante
      const blob = await res.blob();
      const url  = window.URL.createObjectURL(blob);
      const a    = document.createElement('a');
      a.href = url;
      a.download = file.name.replace(/\.pdf$/i, '') + '_SOSFIRE.pdf';
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);

      setMsg('✅ PDF elaborato e scaricato!');
      setFile(null);
    } catch(e) {
      setMsg('❌ ' + e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ maxWidth:640 }}>
      <div className="card">
        <h3 style={{ margin:'0 0 6px', fontSize:15 }}>📄 Quindicizza verbali</h3>
        <p style={{ margin:'0 0 16px', fontSize:13, color:'#6b7280', lineHeight:1.5 }}>
          Carica un verbale ricevuto dal fornitore: il logo e le intestazioni verranno
          sostituiti automaticamente con quelli di SOS FIRE, pronti per il cliente.
        </p>

        {/* AREA DROP */}
        <div
          onDragOver={e=>{e.preventDefault(); setDragOver(true);}}
          onDragLeave={()=>setDragOver(false)}
          onDrop={e=>{e.preventDefault(); setDragOver(false); onFile(e.dataTransfer.files[0]);}}
          onClick={()=>document.getElementById('quindicizza-input').click()}
          style={{
            border:`2px dashed ${dragOver?'#b30000':'#d1d5db'}`,
            borderRadius:10, padding:'32px 20px', textAlign:'center',
            cursor:'pointer', background: dragOver?'#fff5f5':'#fafafa',
            transition:'all .15s',
          }}>
          <input id="quindicizza-input" type="file" accept=".pdf" style={{display:'none'}}
            onChange={e=>onFile(e.target.files[0])} />
          <div style={{ fontSize:36, marginBottom:8 }}>📄</div>
          {file ? (
            <div>
              <div style={{ fontWeight:600, fontSize:14, color:'#b30000' }}>{file.name}</div>
              <div style={{ fontSize:12, color:'#9ca3af', marginTop:2 }}>
                {(file.size/1024/1024).toFixed(1)} MB — clicca "Elabora" per procedere
              </div>
            </div>
          ) : (
            <div>
              <div style={{ fontWeight:600, fontSize:14 }}>Trascina qui il PDF o clicca per selezionarlo</div>
              <div style={{ fontSize:12, color:'#9ca3af', marginTop:2 }}>Solo file PDF</div>
            </div>
          )}
        </div>

        {msg && (
          <div style={{
            marginTop:12, fontSize:13, padding:'8px 12px', borderRadius:6,
            background: msg.startsWith('✅')?'#f0fdf4':'#fef2f2',
            color: msg.startsWith('✅')?'#16a34a':'#dc2626',
          }}>{msg}</div>
        )}

        <div style={{ display:'flex', gap:8, marginTop:16 }}>
          <button className="btn btn-primary" onClick={elabora} disabled={!file||loading}>
            {loading ? '⏳ Elaborazione...' : '🎯 Elabora e scarica'}
          </button>
          {file && !loading && (
            <button className="btn btn-secondary" onClick={()=>{setFile(null); setMsg('');}}>
              ✕ Annulla
            </button>
          )}
        </div>
      </div>

      <div className="card" style={{ marginTop:16 }}>
        <h4 style={{ margin:'0 0 8px', fontSize:13 }}>Cosa viene modificato</h4>
        <ul style={{ margin:0, paddingLeft:18, fontSize:12, color:'#6b7280', lineHeight:1.8 }}>
          <li>Logo del fornitore → <strong>logo SOS FIRE</strong></li>
          <li>Intestazione azienda in alto a destra → <strong>dati SOS FIRE</strong></li>
          <li>Rimozione del blocco dati del fornitore</li>
          <li>Nome cliente ripulito dai codici interni (es. "019 - SOS FIRE SRLS - ")</li>
        </ul>
      </div>
    </div>
  );
}
